module.exports = __webpack_public_path__ + "static/media/sf-test-4.0028b643.mp3";